import { Alert, Box, Button, Container, FormControl, Grid, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import { API_URL } from "../../Constants";
import { Link, useNavigate } from "react-router-dom";
import { axiosClient } from "../AxiosClient";
import VideollamadaModal from "./VideollamadaModal";
import { toBogotaParts } from "./solicitudFechaHora";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const ButtonAdd = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    color: '#ffff',
    margin: '0px 1rem',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
})

const titles = ["Comercio", "Cel Comercio", "Paso", "Nombre cliente", "Cédula", "Versión", "Celular", "Fecha Inicio", "Hora Inicio"];
const urlApi = API_URL;

export default function Solicitud() {
    const navigate = useNavigate();
    const [data, setData] = useState();
    const rowsPerPage = 20;
    const [numberPage, setNumberPage] = useState(0);
    const [searcher, setSearcher] = useState();
    const [modalVideollamada, setModalVideollamada] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("info");

    useEffect(() => {
        axiosClient.get(`/v1/request-progress`, {
            params: {
                page: numberPage,
                sort: 'createdDate,desc',
                size: rowsPerPage,
                search: searcher ? `clientName:'*${searcher}*' OR documentNumber:'*${searcher}*' OR nameCommerce:'*${searcher}*' OR document:'*${searcher}*'${!isNaN(searcher) ? ` OR commerceId:'*${searcher}*'` : ''}` : ''
            }
            })
            .then(response => {
                setData(response.data);
            })
            .catch(error => {
                if (error.response) {
                    console.log("Error with Axios");
                } else {
                    console.log("Bad request: " + error.message);
                }
            });
    }, [])

    console.log(data)

    const handleUpdate = () => {
        axiosClient.get(`/v1/request-progress`, {
            params: {
                page: numberPage,
                sort: 'createdDate,desc',
                size: rowsPerPage,
                search: searcher ? `clientName:'*${searcher}*' OR documentNumber:'*${searcher}*' OR nameCommerce:'*${searcher}*' OR document:'*${searcher}*'${!isNaN(searcher) ? ` OR commerceId:'*${searcher}*'` : ''}` : ''
            }
        })
        .then(response => {
            setData(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("Error with Axios");
            } else {
                console.log("Bad request: " + error.message);
            }
        });
    }

    const handleChangePage = (event, newPage) => {
        setNumberPage(newPage)
        axiosClient.get(`/v1/request-progress`, {
            params: {
                page: newPage,
                sort: 'createdDate,desc',
                size: rowsPerPage,
                search: searcher ? `clientName:'*${searcher}*' OR documentNumber:'*${searcher}*' OR nameCommerce:'*${searcher}*' OR document:'*${searcher}*'${!isNaN(searcher) ? ` OR commerceId:'*${searcher}*'` : ''}` : ''
            }
        })
        .then(response => {
            setData(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("Error with Axios");
            } else {
                console.log("Bad request: " + error.message);
            }
        });
    }

    const handleChangeSearcher = (event) => {
        setSearcher(event.target.value)
    }

    const handleSearcher = () => {
        let number = numberPage;
        if(number != 0) {
            number = 0;
            setNumberPage(0);
        }
        axiosClient.get(`/v1/request-progress`, {
            params: {
                page: number,
                sort: 'createdDate,desc',
                size: rowsPerPage,
                search: searcher ? `clientName:'*${searcher}*' OR documentNumber:'*${searcher}*' OR nameCommerce:'*${searcher}*' OR document:'*${searcher}*'${!isNaN(searcher) ? ` OR commerceId:'*${searcher}*'` : ''}` : ''
            }
        })
        .then(response => {
            setData(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("Error with Axios");
            } else {
                console.log("Bad request: " + error.message);
            }
        });
    }

    console.log(data)

    const showSnackbar = (message, severity = "info") => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === "clickaway") return;
        setSnackbarOpen(false);
    };

    const handleCloseVideollamadaModal = () => {
        setModalVideollamada(false);
    };

    return (
        <React.Fragment>
            <br></br>
            <Box sx={{width: '100%', marginTop: '1.7rem'}}>
                <Container>
                    <Item></Item>
                    <Item>.</Item>
                    <Grid container spacing={4} sx={{justifyContent: 'space-between', alignItems: 'center'}}>
                        <Grid item>
                            <h1>Solicitudes</h1>
                        </Grid>
                        <Grid item sx={{display: 'flex', gap: '0.5rem', width: '50vw'}}>
                            <Grid item xs={6}>
                                <Box width={'100%'} mt={5} mb={2}>
                                    <FormControl fullWidth>
                                        <TextField id="comercio" label="Identificación, Id o nombre del comercio" value={searcher} onChange={handleChangeSearcher} variant="outlined"></TextField>
                                    </FormControl>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box textAlign={'center'} mb={8} mt={5.7}>
                                    <ButtonAdd onClick={handleSearcher}>Buscar</ButtonAdd>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box textAlign={'center'} mb={8} mt={5.7}>
                                    <ButtonAdd onClick={handleUpdate}>Actualizar</ButtonAdd>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box textAlign={'center'} mb={8} mt={5.7}>
                                    <ButtonAdd onClick={() => navigate("/homeAdmin/solicitudes/experian")}>Experian</ButtonAdd>
                                </Box>
                            </Grid>
                            <Grid item>
                                <Box textAlign={'center'} mb={8} mt={5.7}>
                                    <ButtonAdd onClick={() => setModalVideollamada(true)}>Videollamada</ButtonAdd>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Box>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        {titles.map(title => (
                                            <TableCell key={title}>{title}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data?.content?.map(item => (
                                        <TableRow key={item.conversation.uuid}>
                                            <TableCell>{item.commerce.name}</TableCell>
                                            <TableCell>{item.conversation.commerceCellphone}</TableCell>
                                            <TableCell>{item.conversation.descriptionStatus}</TableCell>
                                            <TableCell>{item.conversation.clientName != null ? `${item.conversation.clientName} ${item.conversation.clientLastName}` : item.conversation.clientLastName}</TableCell>
                                            <TableCell>
                                                {item.conversation.whatsappVersion === "V4" ?
                                                <Link to={`/homeAdmin/solicitudes/v4/detail/${item.conversation.whatsappConversationUuid}`}>{item.conversation.documentNumber}</Link>
                                                : item.conversation.isOtherOption != true ? <Link to={`/homeAdmin/solicitudes/detail/${item.conversation.uuid}`}>{item.conversation.documentNumber}</Link>
                                                :
                                                <Link to={`/homeAdmin/solicitudes/detail/option/${item.conversation.uuid}`}>{item.conversation.documentNumber}</Link>}
                                            </TableCell>
                                            <TableCell>{item.conversation.whatsappVersion ?? ""}</TableCell>
                                            <TableCell>{item.conversation.clientCellphone}</TableCell>
                                            <TableCell>{toBogotaParts(item.conversation.createdDate)?.date}</TableCell>
                                            <TableCell>{toBogotaParts(item.conversation.createdDate)?.time}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            <TablePagination
                            rowsPerPageOptions={[rowsPerPage]}
                            count={(data?.totalElements)}
                            rowsPerPage={rowsPerPage}
                            page={numberPage}
                            onPageChange={handleChangePage}
                            />
                        </TableContainer>
                    </Box>
                </Container>
            </Box>
            <VideollamadaModal
                activeModal={modalVideollamada}
                handleModal={handleCloseVideollamadaModal}
                onError={(message) => showSnackbar(message, "error")}
            />
            <Snackbar open={snackbarOpen} autoHideDuration={5000} onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: "100%" }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </React.Fragment>
    )
}